module.exports = __webpack_public_path__ + "img/EASY-20.7a4351ad.png";